package com.vamvisions.main.portfolio.presentation.document

sealed interface DocumentAction {
    data object Retry : DocumentAction
}
